var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStarInShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-star-in-shield_svg__clip0_772_1687)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.973 2.28A18.195 18.195 0 0010.532.763 18.195 18.195 0 003.09 2.281l-.011.005a1.881 1.881 0 00-1.099 1.72v-.002h.681l-.68.005v-.003 6.143a10.291 10.291 0 006.596 9.606l.84.322c.717.276 1.51.276 2.228 0l.84-.323a10.29 10.29 0 006.596-9.605V4.004h-.68l.68.005v-.003a1.881 1.881 0 00-1.098-1.72l-.011-.005z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.764 11.613l1.79 1.133c.228.145.512-.07.444-.337l-.517-2.034a.311.311 0 01.1-.314l1.605-1.336c.21-.175.102-.525-.169-.542l-2.095-.136a.298.298 0 01-.257-.19l-.781-1.968a.295.295 0 00-.552 0l-.781 1.968a.299.299 0 01-.257.19l-2.095.136c-.271.017-.38.367-.17.542l1.605 1.336a.31.31 0 01.1.315l-.479 1.885c-.081.32.26.579.534.405l1.662-1.053a.29.29 0 01.313 0z",
    fill: "#1AB9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.053 5.19a.976.976 0 011.465.451l.691 1.742 1.852.12c.917.06 1.22 1.197.56 1.746l-1.423 1.184.46 1.808c.206.812-.675 1.584-1.47 1.08l-1.58-1.001-1.455.921c-.84.532-1.778-.282-1.558-1.148l.422-1.66L6.594 9.25c-.659-.549-.357-1.686.56-1.746l1.852-.12.692-1.742a.976.976 0 01.355-.45zm.347 6.998l.364-.575-.365.574v.001zm.73-1.15l.974.617-.282-1.11a.994.994 0 01.32-1.005l.004-.003.885-.736-1.157-.075a.98.98 0 01-.843-.62l-.423-1.066-.424 1.067a.98.98 0 01-.842.619h-.004l-1.153.075.888.739a.992.992 0 01.321 1.004m-.282 1.111l-.688.436a.337.337 0 01.376.015c.091.07.147.197.115.323l.197-.774zm2.018-.617a.975.975 0 00-1.044 0m3.055-.832v.002-.002z",
    fill: "#1AB9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-star-in-shield_svg__clip0_772_1687"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.761 .761)",
    d: "M0 0h19.523v19.523H0z"
  })))));
}
export default SvgIconStarInShield;